import React from "react";
import dayjs from "dayjs";
import { useSummary } from "../api/summary/use-summary";
import TitlePage from "../components/section/TitlePage/Titlepage";
import { Refresh } from "../assets/img";
import Status from "./Dashboard/Components/Status";
import DashboardMap from "./Dashboard/Components/DashboardMap";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import OrderDetails from "./Dashboard/Components/OrderDetails";
import AnotherOrder from "./Dashboard/Components/AnotherOrder";
import Bulletin from "./Dashboard/Components/Bulletin";

const DashboardStatusPage = () => {
  const formattedDate = dayjs().format("YYYY.MM.DD HH:mm");
  const { data: summary } = useSummary();

  return (
    <div>
      <div className="flex justify-between">
        <TitlePage title="주요 현황" size="text-[14px]" />
        <div className="text-secondary-grey items-center flex">
          업데이트 {formattedDate}
          <img
            alt="refresh_icon"
            className="ml-1 cursor-pointer"
            src={Refresh}
            width={9}
          />
        </div>
      </div>

      <Status
        todayWarehouseStatus={summary?.data?.todayInbound?.totalQuantity}
        shipmentStatus={summary?.data?.todayOutbound?.totalQuantity}
        todayOrderStatus={summary?.data?.todayOrderReceivedCount}
        todaySalesStatus={summary?.data?.todayTotalSales}
        hospitalStatus={summary?.data?.membership?.hospitals}
        patientStatus={summary?.data?.membership?.patients}
      />

      <div className="mt-10">
        <div className="flex">
          <TitlePage size="text-[14px]" title="일별 매출" />
          <p className="mt-1 cursor-pointer text-title-grey flex ml-2">
            더보기
            <ChevronRightIcon className="-mt-3.5" width={15} />
          </p>
        </div>
        <DashboardMap chartData={summary?.data?.monthDailySales ?? []} />
      </div>
      <div className="mt-10 space-x-4 flex">
        <OrderDetails orderDetail={summary?.data?.todayRecentOrders ?? []} />
        <AnotherOrder
          totalPriceCancelation={
            summary?.data?.todayAfterSales?.cancel?.amount ?? 0
          }
          totalPriceReturned={
            summary?.data?.todayAfterSales?.return?.amount ?? 0
          }
          totalQtyCancelation={
            summary?.data?.todayAfterSales?.cancel?.count ?? 0
          }
          totalQtyReturned={summary?.data?.todayAfterSales?.return?.count ?? 0}
          exchangeQtyRequest={
            summary?.data?.todayAfterSales?.exchange?.count ?? 0
          }
          defectAcceptance={summary?.data?.todayAfterSales?.defect?.count ?? 0}
        />
        <Bulletin
          productInquiry={
            summary?.data?.todayEngagement?.productInquiryCount ?? 0
          }
          productReview={
            summary?.data?.todayEngagement?.productReviewCount ?? 0
          }
          oneOnOneInquiry={
            summary?.data?.todayEngagement?.oneToOneInquiryCount ?? 0
          }
        />
      </div>
    </div>
  );
};

export default DashboardStatusPage;
